import { WorkspaceRoleSchema } from "../../workspace";
import { DesignSystemRole } from "./ds-role";
import { z } from "zod";
export const DesignSystemInvitation = z.object({
    id: z.string(),
    designSystemId: z.string(),
    workspaceInvitationId: z.string(),
    designSystemRole: DesignSystemRole.optional(),
    workspaceRole: WorkspaceRoleSchema,
});
